// Extend this class for custom errors that should not be displayed in the toast
export class SilencedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SilencedError";
  }
}
